// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JH_4","footer":"styles_footer__2waMT"};